import { GRAPHS } from 'modules/campaigns/constants/graphTypes';
import * as FIELDS from '../../fields';
import metrics from '../../metrics';

const graph = {
    type: GRAPHS.BAR,
    endpoint: 'campaign-report-by-country-performance',
    metrics: [
        metrics.SPENT,
        metrics.VIDEO_VISIBLE_IMPRESSIONS,
        metrics.VIDEO_IMPRESSIONS,
        metrics.CLICKS,
        metrics.VIDEO_VCTR,
        metrics.VIDEO_CTR,
        metrics.AVERAGE_CPC,
        metrics.CVR,
        metrics.CVR_CLICKS,
        metrics.CVR_VIEWS,
        metrics.CONVERSIONS,
        metrics.CONVERSIONS_CLICKS,
        metrics.CONVERSIONS_VIEWS,
        metrics.CPA,
        metrics.CPA_CLICKS,
        metrics.CPA_VIEWS,
        metrics.VIDEO_VCPM,
        metrics.VIDEO_CPM,
        metrics.CONVERSIONS_VALUE,
        metrics.ROAS,
    ],
    maxAllowedSelectedMetrics: 4,
    maxXAxisValues: 8,
    shouldUseGridDataSrc: true,
    displayTotalsInLegendRow: false,
    enableLongTextTickFormatting: true,
    graphProps: {
        xAxisDataKeyWithIntl:
            intl =>
            ({ [FIELDS.COUNTRY_CODE.field]: countryCode }) =>
                intl.formatMessage({
                    id: `${FIELDS.COUNTRY_CODE.renderParams.msgIdPrefix}.${countryCode}`,
                    defaultMessage: countryCode,
                }),
    },
};

export default graph;
